export enum Language {
     None = 0,
     English = 1,
     Spanish = 2,
}